import { Typography } from "@mui/material";
import React from "react";

export default function CoreTypographyBody1(props) {
  return <Typography {...props}>{props?.children}</Typography>;
}
